var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplyWithCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40067 9.7429L9.40067 11.4629C9.40067 11.6209 9.49538 11.7638 9.64178 11.8266C9.78812 11.8894 9.95811 11.8601 10.0744 11.7519L13.8737 8.21865C13.9543 8.14372 14 8.03906 14 7.92966C14 7.82015 13.9543 7.7155 13.8737 7.64056L10.0744 4.10735C9.95811 3.99928 9.78809 3.96982 9.64178 4.03262C9.49534 4.09542 9.40067 4.2384 9.40067 4.39644L9.40067 6.14109C6.92823 6.36639 4.83712 8.11595 4.22546 10.5404L4.01484 11.3749C3.95546 11.6137 4.07862 11.8602 4.30628 11.9581C4.53394 12.0562 4.79975 11.9772 4.93535 11.7711L4.92935 11.7799C5.81095 10.5153 7.27192 9.743 8.85125 9.743L9.40064 9.743L9.40067 9.7429Z",
    fill: "#076EB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyWithCircle);
export default __webpack_public_path__ + "static/media/reply-with-circle.c0a4f422d47cc301bd2b1a2a0595ac32.svg";
export { ForwardRef as ReactComponent };